import { Fragment } from "react";
import { TbExternalLink } from "react-icons/tb";
import { Grid, IconButton, InputAdornment } from "@mui/material";

import { Label, TextField, AutocompleteMultiSelect } from "../../../components";
import { useSelector } from "react-redux";

export default function FormTwo({ list, formikProps, editState }) {
  const agencyID =
    useSelector((state) => state.memberDetails.agencyID) ||
    sessionStorage.getItem("agencyID");

  return (
    <Fragment>
      {!agencyID && (
        <Fragment>
          <Grid size={4}>
            <AutocompleteMultiSelect
              required={agencyID ? false : true}
              name="siteCategory"
              label={"Business Category"}
              disabled={!editState}
              forcePopupIcon={!editState ? false : true}
              formikProps={formikProps}
              defaults={{
                primaryKey: "name",
                displayLabel: "name",
              }}
              options={list?.categories}
              placeholder="Select Category"
              onChange={(_, arr, reason, option) => {
                handleChange(arr, option, reason, "siteCategory", "name");
              }}
            />
          </Grid>

          {formikProps.values.siteCategory.includes("Others") && (
            <Fragment>
              <Grid size={4}>
                <TextField
                  required
                  disabled={!editState}
                  formikProps={formikProps}
                  name="others_category"
                  label={"Enter your other category"}
                  placeholder={"Enter your other category"}
                />
              </Grid>
            </Fragment>
          )}
        </Fragment>
      )}

      {!agencyID && (
        <Grid size={4}>
          <AutocompleteMultiSelect
            required={true}
            name="audienceLocation"
            label={"Audience Location"}
            disabled={!editState}
            forcePopupIcon={!editState ? false : true}
            formikProps={formikProps}
            defaults={{
              primaryKey: "country_code",
              displayLabel: "country_name",
            }}
            options={list?.locations}
            placeholder="Select Location"
            onChange={(_, arr, reason, option) =>
              handleChange(
                arr,
                option,
                reason,
                "audienceLocation",
                "country_code"
              )
            }
          />
        </Grid>
      )}

      {!agencyID && (
        <Grid size={4}>
          <AutocompleteMultiSelect
            required={true}
            label={"Audience Language"}
            name="audienceLanguages"
            disabled={!editState}
            forcePopupIcon={!editState ? false : true}
            formikProps={formikProps}
            defaults={{
              primaryKey: "code",
              displayLabel: "language",
            }}
            options={list?.languages}
            placeholder="Select Language"
            onChange={(_, arr, reason, option) =>
              handleChange(arr, option, reason, "audienceLanguages", "code")
            }
          />
        </Grid>
      )}

      <Grid size={4}>
        <TextField
          label="About"
          disabled={!editState}
          formikProps={formikProps}
          placeholder="About"
          name="about"
          required
          multiline
          inputProps={{ maxLength: 255 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <span style={{ fontSize: 12, color: "#888" }}>
                  {`${formikProps.values.about?.length}/255`}
                </span>
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      {!agencyID && (
        <Fragment>
          <Grid size={12}>
            <Label title="Social Media URL's" />
          </Grid>

          <Grid size={4}>
            <TextField
              disabled={!editState}
              formikProps={formikProps}
              label={"Facebook URL"}
              name="socialMedia.facebook"
              placeholder={"Enter your facebook url"}
              InputProps={{
                endAdornment: !!formikProps.values.socialMedia.facebook &&
                  !editState && (
                    <IconButton
                      onClick={() =>
                        linkOpen(
                          "https://facebook.com/" +
                            formikProps.values.socialMedia.facebook.replace(
                              /(?:https?|ftp):\/\/[\n\S]+/g,
                              ""
                            )
                        )
                      }
                    >
                      <TbExternalLink />
                    </IconButton>
                  ),
              }}
            />
          </Grid>

          <Grid size={4}>
            <TextField
              disabled={!editState}
              formikProps={formikProps}
              name="socialMedia.instagram"
              label={"Instagram URL"}
              placeholder={"Enter your instagram url "}
              InputProps={{
                endAdornment: !!formikProps.values.socialMedia.instagram &&
                  !editState && (
                    <IconButton
                      onClick={() =>
                        linkOpen(
                          "https://instagram.com/" +
                            formikProps.values.socialMedia.instagram.replace(
                              /(?:https?|ftp):\/\/[\n\S]+/g,
                              ""
                            )
                        )
                      }
                    >
                      <TbExternalLink />
                    </IconButton>
                  ),
              }}
            />
          </Grid>

          <Grid size={4}>
            <TextField
              disabled={!editState}
              formikProps={formikProps}
              name="socialMedia.twitter"
              label={"Twitter URL"}
              placeholder={"Enter your twitter url"}
              InputProps={{
                endAdornment: !!formikProps.values.socialMedia.twitter &&
                  !editState && (
                    <IconButton
                      onClick={() =>
                        linkOpen(
                          "https://twitter.com/" +
                            formikProps.values.socialMedia.twitter.replace(
                              /(?:https?|ftp):\/\/[\n\S]+/g,
                              ""
                            )
                        )
                      }
                    >
                      <TbExternalLink />
                    </IconButton>
                  ),
              }}
            />
          </Grid>

          <Grid size={4}>
            <TextField
              disabled={!editState}
              formikProps={formikProps}
              name="socialMedia.whatsapp"
              label={"Whatsapp Number"}
              placeholder={"Enter your whatsapp number"}
              InputProps={{
                endAdornment: !!formikProps.values.socialMedia.whatsapp &&
                  !editState && (
                    <IconButton
                      onClick={() =>
                        linkOpen(
                          "https://wa.me/" +
                            formikProps.values.socialMedia.whatsapp
                        )
                      }
                    >
                      <TbExternalLink />
                    </IconButton>
                  ),
              }}
            />
          </Grid>
        </Fragment>
      )}
    </Fragment>
  );

  function handleChange(arr, { option }, reason, name, displayName) {
    formikProps.setValues((prevVal) => ({
      ...prevVal,
      [name]: setValuesOfDropDown(prevVal[name]),
    }));

    function setValuesOfDropDown(val) {
      let values = [...val];

      if (reason === "removeOption") {
        const nameToDropDown = {
          audienceLocation: "country_code",
          siteCategory: "name",
          audienceLanguages: "code",
        };

        let dropDownName = nameToDropDown[name];

        if (option[dropDownName]) {
          values = [
            ...values.filter((items) => items !== option[dropDownName]),
          ];
        } else {
          values.pop();
        }
      }
      if (reason === "selectOption") {
        values.push(option[displayName]);
      }

      return values;
    }
  }

  function linkOpen(val) {
    window.open(val, "_blank");
  }
}
